import { render } from "./MyVendorCode.vue?vue&type=template&id=280c295e&scoped=true"
import script from "./MyVendorCode.vue?vue&type=script&lang=js"
export * from "./MyVendorCode.vue?vue&type=script&lang=js"

import "./MyVendorCode.vue?vue&type=style&index=0&id=280c295e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280c295e"]])

export default __exports__